export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/30705c7323e3-tooliconspeech.jpg',
  },
  title: 'Can you tell us more about the scam?',
  placeholderText: 'E.g. How you came across the scam and what type of scam it was?',
}
